import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';

interface FilterOptions {
  searchText: string;
  contentType: string; // 'FOTOGRAFIAS' | 'PORTADAS' | ''
  subCategory: string;
  sortBy: string;
  yearFrom: number;
  yearTo: number;
  dateFrom: string;
  dateTo: string;
}

interface SubCategory {
  id: string;
  name: string;
  descript: string;
}

@Component({
  selector: 'app-sidebar-filters',
  templateUrl: './sidebar-filters.component.html',
  styleUrls: ['./sidebar-filters.component.scss']
})
export class SidebarFiltersComponent implements OnInit {
  @Input() currentPage: string = ''; // 'fotografias' | 'portadas'
  @Output() filtersChanged = new EventEmitter<FilterOptions>();

  filters: FilterOptions = {
    searchText: '',
    contentType: '',
    subCategory: '',
    sortBy: 'title',
    yearFrom: 1900,
    yearTo: 2024,
    dateFrom: '',
    dateTo: ''
  };

  // Opciones de contenido
  contentTypes = [
    { value: '', label: 'Todos', icon: 'fas fa-list' },
    { value: 'FOTOGRAFIAS', label: 'Fotografías', icon: 'fas fa-camera' },
    { value: 'PORTADAS', label: 'Portadas', icon: 'fas fa-newspaper' }
  ];

  // Opciones de ordenamiento
  sortOptions = [
    { value: 'title', label: 'Título (A-Z)' },
    { value: 'title_desc', label: 'Título (Z-A)' },
    { value: 'date_desc', label: 'Más recientes' },
    { value: 'date_asc', label: 'Más antiguos' },
    { value: 'author', label: 'Autor (A-Z)' }
  ];

  // Subcategorías dinámicas
  subCategories: SubCategory[] = [];
  listCategoria: any = { response: { list: [] } };
  listSubCategoria: any = { response: { list: [] } };

  // Configuración de años
  minYear: number = 1900;
  maxYear: number = 2024;

  // Estado del panel
  isCollapsed: boolean = false;

  constructor(private novedadesService: NovedadesService) {}

  ngOnInit(): void {
    // Establecer el tipo de contenido basado en la página actual
    if (this.currentPage === 'fotografias') {
      this.filters.contentType = 'FOTOGRAFIAS';
    } else if (this.currentPage === 'portadas') {
      this.filters.contentType = 'PORTADAS';
    }

    // Inicializar años
    this.filters.yearFrom = this.minYear;
    this.filters.yearTo = this.maxYear;

    // Cargar categorías y subcategorías
    this.loadCategories();
  }

  private loadCategories(): void {
    this.novedadesService.obtenerCategoria().subscribe((data) => {
      this.listCategoria = data;

      // Cargar subcategorías para el tipo de contenido actual
      if (this.filters.contentType) {
        this.loadSubCategories();
      }
    });
  }

  private loadSubCategories(): void {
    if (!this.listCategoria.response?.list?.length) return;

    // Buscar el ID de la categoría por nombre
    const category = this.listCategoria.response.list.find(
      (cat: any) => cat.name === this.filters.contentType
    );

    if (category) {
      this.novedadesService.obtenerSubCategoria(category.id).subscribe((data) => {
        this.listSubCategoria = data;
        this.subCategories = data.response?.list?.map((item: any) => ({
          id: item.id,
          name: item.name,
          descript: item.descript || item.name
        })) || [];
      });
    }
  }

  onContentTypeChange(): void {
    // Limpiar subcategoría cuando cambie el tipo de contenido
    this.filters.subCategory = '';
    this.loadSubCategories();
    this.emitFilters();
  }

  onSearchTextChange(): void {
    this.emitFilters();
  }

  onSubCategoryChange(): void {
    this.emitFilters();
  }

  onSortByChange(): void {
    this.emitFilters();
  }

  onYearRangeChange(): void {
    this.emitFilters();
  }

  onDateRangeChange(): void {
    this.emitFilters();
  }

  resetFilters(): void {
    this.filters = {
      searchText: '',
      contentType: this.currentPage === 'fotografias' ? 'FOTOGRAFIAS' :
                   this.currentPage === 'portadas' ? 'PORTADAS' : '',
      subCategory: '',
      sortBy: 'title',
      yearFrom: this.minYear,
      yearTo: this.maxYear,
      dateFrom: '',
      dateTo: ''
    };

    this.loadSubCategories();
    this.emitFilters();
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  private emitFilters(): void {
    this.filtersChanged.emit({ ...this.filters });
  }

  // Métodos de utilidad para el template
  hasActiveFilters(): boolean {
    return !!(
      this.filters.searchText?.trim() ||
      this.filters.subCategory ||
      this.filters.yearFrom !== this.minYear ||
      this.filters.yearTo !== this.maxYear ||
      this.filters.dateFrom ||
      this.filters.dateTo ||
      this.filters.sortBy !== 'title'
    );
  }
}